import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tbdc-icon-menu-header" }
const _hoisted_2 = ["label"]
const _hoisted_3 = {
  key: 0,
  class: "tbdc-icon-menu-dropdown tbdc-icon-menu-hidden"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tbdc-icon-menu', 'tbdc-icon-menu-' + _ctx.menuName]),
    onMouseover: _cache[0] || (_cache[0] = () => _ctx.showIconMenu()),
    onMouseleave: _cache[1] || (_cache[1] = () => _ctx.hideIconMenu())
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(), (item, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: item.name,
        label: item.name,
        ref_for: true,
        ref: `item-${index}`
      }, [
        (item.enabled && item.shouldShow)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: _normalizeClass(["tbdc-icon-menu-icon", {'tbdc-icon-menu-hidden': !item.selected, 'tbdc-icon-menu-icon-selected': item.selected}])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.icon), 1)
              ]),
              _: 2
            }, 1032, ["class"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2))
    }), 128)),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_ctx.getItems().length > 0)
            ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                activator: _withCtx(({ props: menuProps }) => [
                  _createVNode(_component_v_icon, _mergeProps(menuProps, { class: "tbdc-icon-menu-dropdown-icon" }), {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-menu", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, { class: "tbdc-icon-menu-header" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.convertMdiBracketToIcon(_ctx.menuTitle)
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems(), (item, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: item.name,
                          label: item.name,
                          ref_for: true,
                          ref: `item-${index}`,
                          onClick: (e) => _ctx.select(e, index)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_action, null, {
                              default: _withCtx(() => [
                                (item.enabled)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: _normalizeClass(["tbdc-icon-menu-icon", {'tbdc-icon-menu-icon-selected': item.selected}])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.icon), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  (item.selected)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("message.hide", {item: _ctx.$t(item.translation)})), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("message.show", {item: _ctx.$t(item.translation)})), 1))
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}